import { Field, Form, Formik } from "formik";
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { AdjustRefundSection, AdjustmentModalInnerBoxes, ConfirmationModalWrapper, SubmitButtonWrapper } from "./PaymentAdjustmentModalStyled";
import * as Yup from "yup";
import RadioButton from "web/components/RadioButton";
import { Modal, ModalBody, ModalFooter, ModalHeader, Tooltip } from "reactstrap";
import NumberInput from "web/components/form-elements/NumberInput";
import information from "web/assets/images/informationIcon.png";
import Textarea from "web/components/form-elements/TextArea";
import HOCButton from "web/components/Button";
import AlertModal from "web/components/AlertModal";
import { ptPlusPaymentAdjumentRequestSend } from "redux/actions/adminPtPlusOrdersPaymentAdjustments";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PaymentAdjustmentModal = ({ selectedOrderDetails, toggle }) => {

  let dispatch = useDispatch()
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
  const [tooltip, setTooltip] = useState(false)
  const [tooltipSection, settTooltipSection] = useState("")
  const [modal, setModal] = useState(false)
  const [modalLink, setModalLink] = useState('/')
  const [alertType, setAlertType] = useState('')
  const [modalContent, setModalContent] = useState('')
  const [confirmationModal, setConfirmationModal] = useState(false)

  const adjustmentRadioOptions = [
    { value: 'DEBIT', label: 'Refund to Buyer', tooltip: "REFUND TO BUYER: This adjustment will TAKE BACK funds from the seller and REFUND the buyer." },
    { value: 'CHARGE', label: 'Charge the Buyer', tooltip: "CHARGE THE BUYER: This adjustment will CHARGE the buyer and PAY the seller." },
  ];
  const INITIAL_VALUES = {
    adjType: 'DEBIT',
    adjAmount: '',
    chargeReason: '',
    comments: '',
  };

  const VALIDATION_SCHEMA = Yup.object().shape({
    adjType: Yup.string().required("Adjustment Type is required."),
    adjAmount: Yup.number().required("Adjustment Amount is required.")
              .required("Adjustment Amount is required.")
              .min(0.01, "Adjustment Amount must be a positive number and greater than 0."),
    chargeReason: Yup.string()
                  .required("Description is required."),
    comments: Yup.string().required("Comments are required."),
  });

  const showToolTip = (infoSection, infoTxt) => {
    return (
      <>
        <img
          id={infoSection}
          src={information}
          style={{ position: "relative", top: "-1px", marginLeft: "6px", }}
          alt='information-icon'
        />
        <Tooltip
          placement="right"
          isOpen={tooltip && tooltipSection === infoSection}
          target={infoSection}
          toggle={() => {
            setTooltip(!tooltip);
            settTooltipSection(tooltipSection === "" ? infoSection : "");
          }}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  const postPaymentAdjusmentsRequest = async (props) => {
    const postData = props.values
    const data = {
      "orderId": selectedOrderDetails?.orderNo,
      "adjAmount": postData?.adjAmount,
      "chargeReason": postData?.chargeReason,
      "comments": postData?.comments,
      "adjType": postData?.adjType
    }
    const response = await dispatch(ptPlusPaymentAdjumentRequestSend(data))
    if (response?.success) {
      setModalContent(response?.data?.msg)
      setModalLink('')
      setAlertType('success')
      setModal(!modal)
    } else {
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!')
        setModalLink('')
        setModal(!modal)
      }
    }

  }

  return (
    <>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const { isValid, dirty, values, setFieldValue } = props;
          return (
            <>
              <div>
                {loaderVisible && <Spinner />}
                <Form>
                  {/* {Request Modal Popup Header} */}
                  <AdjustmentModalInnerBoxes>
                    <div className={"exchange-modal-header"}>
                      <h1>Payment Adjustment</h1>
                      <img src={CloseIcon} alt="close-icon" onClick={toggle} />
                    </div>
                  </AdjustmentModalInnerBoxes>
                  {/* {Request Form Modal Popup} */}
                  <AdjustRefundSection>
                    <div className=" mx-3 claim-info-section">
                      <div>
                        <h6>Adjustment Type</h6>
                        <div style={{ display: 'flex', marginTop: '6px' }}>
                          {adjustmentRadioOptions &&
                            adjustmentRadioOptions.map((value, index) => (
                              <div key={index} style={{ marginRight: '40px' }}>
                                <Field
                                  component={RadioButton}
                                  name='adjType'
                                  id={value.value}
                                  defaultValue={adjustmentRadioOptions[0].value}
                                  onSelect={(e) => setFieldValue('adjType', value.value)}
                                  label={value.label}
                                  checked={values.adjType === value.value}
                                />
                                <span>{showToolTip(value.value, value.tooltip)}</span>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: "space-between", marginRight: '10px', marginTop: '10px' }}>
                        <p className="mt-1 w-min-150">Adjustment Amount<span style={{ color: '#a30202' }}>&#42;</span></p>
                        <NumberInput
                          name="adjAmount"
                          showErrorMessages={true}
                          decimalScale={2}
                          placeholder="$ 0.00"
                          maxLength={8}
                          // fixedDecimalScale
                        />
                      </div>
                      <div style={{ display: 'flex', justifyContent: "space-between", marginRight: '10px', marginTop: '10px' }}>
                        <p className="mt-1 w-min-150">Description<span style={{ color: '#a30202' }}>&#42;</span></p>
                        {/* <TextInput
                          name='chargeReason'
                          inputType="text"
                          placeholder=""
                          maxLength={100}
                        /> */}
                        <Textarea name="chargeReason" showErrorMessages={true} rows={1} />
                      </div>
                      <div>
                        <p className="mt-0" >Comments<span style={{ color: '#a30202' }}>&#42;</span>
                          </p>
                        <Textarea name="comments" showErrorMessages={true} />
                      </div>
                    </div>


                    <SubmitButtonWrapper>
                      <div className="submit-button-wrapper">
                        <HOCButton
                          type="app-green-button submitBtn"
                          handleClick={() => {
                            if (props?.values?.comments?.length < 10) {
                              setModalContent('Comment should have atleast 10 characters.')
                              setModalLink('')
                              setModal(!modal)
                            }else{
                              setConfirmationModal(true)
                            }
                          }}
                          disabled={!isValid || !dirty}
                        >
                          Submit
                        </HOCButton>
                      </div>
                    </SubmitButtonWrapper>
                  </AdjustRefundSection>
                </Form>
              </div>
              {/* {Request confirmation Modal Popup} */}
              <Modal isOpen={confirmationModal} centered={true} className="payment-adjustment-confirmation-modal">
                <ConfirmationModalWrapper>
                  <ModalHeader
                    toggle={e => {
                      setConfirmationModal(!confirmationModal)
                    }}>
                    <h1>Payment Adjustment</h1>
                  </ModalHeader>
                  <ModalBody>
                    <p>{props?.values?.adjType === 'DEBIT' ?
                      `Are you sure you want to refund $${parseFloat(props?.values?.adjAmount)?.toFixed(2)} to the buyer?` :
                      `Are you sure you want to charge the buyer $${parseFloat(props?.values?.adjAmount)?.toFixed(2)}?`}</p>

                  </ModalBody>
                  <ModalFooter>
                  <button className="no-button" onClick={e => {
                      setConfirmationModal(!confirmationModal)
                    }}>
                      No
                    </button>
                    <button className='yes-button' onClick={() => {
                      postPaymentAdjusmentsRequest(props);
                      setConfirmationModal(!confirmationModal)
                    }}>Yes</button>
                    
                  </ModalFooter>
                </ConfirmationModalWrapper>

              </Modal>
            </>
          )
        }}
      </Formik>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        alertType={alertType}
        content={modalContent}
        callBackAlert={(val) => {
          if (val === "success") toggle()
          else setModal(!modal)
        }}
        link={modalLink}
        // size="sm"
        styleClass="payment-adj-alert-modal"
      />
    </>
  )
}

export default PaymentAdjustmentModal
